// src/features/release-notes/components/ReleaseNotesPrompt.tsx

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocaleState } from 'react-admin';
import { manualLangFromLocale } from '@/features/manual/utils/labels';
import { loadPendingNotes, promptHandlers } from '../session';
import type { ReleaseNote } from '../types';
import { ReleaseNotesDialog } from './ReleaseNotesDialog';

/**
 * Mounted in the signed-in shell, draws nothing until once per session the pending notes come back
 * non-empty (see `loadPendingNotes`). The cross dismisses without acknowledging; «Entendido» or
 * following a note acknowledges all shown.
 */
export const ReleaseNotesPrompt: React.FC = () => {
  const [locale] = useLocaleState();
  const [notes, setNotes] = useState<ReleaseNote[]>([]);
  const lang = useRef(manualLangFromLocale(locale));
  lang.current = manualLangFromLocale(locale);

  useEffect(() => {
    let active = true;
    loadPendingNotes(lang.current).then((pending) => {
      if (active) setNotes(pending);
    });
    return () => {
      active = false;
    };
  }, []);

  const { acknowledge, dismiss } = useMemo(() => promptHandlers(notes, () => setNotes([])), [notes]);

  if (notes.length === 0) return null;
  return <ReleaseNotesDialog notes={notes} onAcknowledge={acknowledge} onDismiss={dismiss} />;
};
